import Vue from 'vue'
import Overlay from '@/components/_partial/_atomic/Overlay'
import Panel from '@/components/_partial/_atomic/panel'
import Modal from '@/components/Modal'
import VRow from '@/components/_partial/_atomic/VRow'
import VCol from '@/components/_partial/_atomic/VCol'

import Pagination from '@/components/_partial/_atomic/Pagination/Pagination'
import PageButton from '@/components/_partial/_atomic/Pagination/PageButton'

import toggleButtonMixin from './_toggleButtonMixin'
import dateRangePickerMixin from './_dateRangePicker'

import pace from 'pace-progress'

// import $ from 'jquery'
// import 'footable'

let listMixin = {
  components: { Vue, Overlay, Panel, Modal, VCol, VRow, Pagination, PageButton },
  mixins: [dateRangePickerMixin, toggleButtonMixin],
  props: ['showSearch'],

  data () {
    return {
      localizedFormat: {},
      statuses: [],
      systemStatuses: [],
      mode: {
        statusMap: {},
        active: false,
        sort: '-id',
        search: {
          q: '',
          show: false,
          doing: false,
          filter: {}
        }
      },
      showLoader: false,
      //
      newItem: {
        showModal: false
      },
      oldItem: {
        showModal: false
      },
      items: [],
      paging: {
        page: 0,
        perPage: 20,
        total: 1,
        pages: 1
      }
    }
  },

  beforeMount () {
    if (this.service.hasOwnProperty('__itemTemplate')) {
      this.itemTemplate = this.service.__itemTemplate
    }
    this.newItem = Object.assign({ showModal: false }, this.itemTemplate)
    this.oldItem = Object.assign({ showModal: false }, this.itemTemplate)
  },

  mounted () {
    this.mode.search.show = !!this.showSearch
    // $('.table-toggleable').footable()
    this.localizedFormat = Vue.config.localizedFormat
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.statuses = []
    // this.reset()
    this.refresh()
  },

  methods: {
    __pageChanged (page, start, end) {
      let needRefresh = this.paging.page !== page
      this.paging.page = page
      if (needRefresh) {
        this.refresh()
      }
    },

    __makeMap (source, compare) {
      let _res = {}
      for (let i in source) {
        _res[i] = compare === source[i]
      }
      return _res
    },

    getById (id) {
      let result = this.items.filter(i => i.id === id)
      if (Array.isArray(result) && result.length) {
        return result[0]
      }
      return false
    },

    toggleSubitems (event, itemId) {
      for (let i in this.items) {
        if (this.items[i].id === itemId) {
          this.items[i].expanded = !this.items[i].expanded
          break
        }
      }
      console.log(event)
    },

    addItemClick () {
      this.newItem.showModal = true
    },

    addItemClose () {
      this.newItem = Object.assign({ showModal: false }, this.itemTemplate)
      this.currentObject = {}
    },

    updateItemClose () {
      this.oldItem = Object.assign({ showModal: false }, this.itemTemplate)
      this.currentObject = {}
    },

    dropItem (id) {
      this.$popup.confirm('Are you sure to delete this item?', 'Confirmation').then(() => {
        this.showLoader = true
        this.service.drop(id, () => {
          this.reset(false)
          this.refresh()
          this.showLoader = false
        },
        () => {
          this.$popup.warning('Can\'t store item on server')
          this.showLoader = false
        })
      })
    },

    toggleSort (field) {
      if (typeof field === 'object') {
        if (field.target) {
          if (field.target.dataset.sortField) {
            field = field.target.dataset.sortField
          }
        }
      }
      let re = new RegExp('-?' + field)
      if (this.mode.sort.match(re)) {
        this.mode.sort = this.mode.sort === '-' + field ? field : '-' + field
        this.refresh(false)
      } else {
        this.mode.sort = field
        this.refresh(false)
      }
    },

    setSortSign () {
      let dt = this.$refs.list
      if (dt) {
        let ths = dt.querySelectorAll('th')
        ths.forEach(item => {
          if (item.dataset.hasOwnProperty('sortField')) {
            item.classList.add('sorting__allow')
            item.classList.remove('sorting_desc')
            item.classList.remove('sorting_asc')
            if (item.dataset.sortField === this.mode.sort) {
              item.classList.add('sorting_asc')
            } else if (item.dataset.sortField === this.mode.sort.replace('-', '')) {
              item.classList.add('sorting_desc')
            }
          }
        })
      }
    },

    doSearch (e) {
      console.log(e)
      this.mode.search.q = e
      this.mode.search.doing = true
      this.refresh(false)
    },

    doClear () {
      this.mode.search.q = ''
      this.mode.search.doing = true
      this.refresh(false)
    },

    onListReceiveCallback (data, response) {
      this.items = []
      data.forEach((i, idx) => {
        i.expanded = false
        this.items.push(i)
      })
      //
      this.paging.page = parseInt(response.headers.get('X-Pagination-Current-Page')) - 1
      this.paging.perPage = parseInt(response.headers.get('X-Pagination-Per-Page'))
      this.paging.total = parseInt(response.headers.get('X-Pagination-Total-Count'))
      this.paging.pages = parseInt(response.headers.get('X-Pagination-Page-Count'))
      //
      this.setSortSign()
      //
      this.showLoader = false
      this.mode.search.doing = this.showLoader

      if (this.hasOwnProperty('onListReceive')) {
        this.onListReceive()
      }
    },

    refresh (loader = true) {
      pace.restart()
      this.showLoader = loader
      let $vm = this
      this.service.getList({
        page: parseInt(this.paging.page) + 1,
        q: this.mode.search.q,
        sort: this.mode.sort,
        filter: Object.assign({
          'status': this.mode.active ? [1, 3, 5] : []
        }, this.mode.search.filter)
      }, this.onListReceiveCallback, (e) => {
        console.log("ERROR:", e)
        $vm.showLoader = false
        $vm.mode.search.doing = false // $vm.showLoader
        $vm.$popup.warning('Can\'t fetch items from server...')
      })
    },

    __buildPaging () {

    },

    setItemStatus (item, status) {
      this.service.update(item, {
        'id': item, 'status': status
      }, result => {
        this.items.forEach((i, ind) => {
          if (i.id === result.id) {
            this.updateItemRow(i)
          }
        })
      }, () => {
        this.$popup.warning('Can\'t set item STATUS on server')
      })
    }

  }

}

export default listMixin
